function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/word-wizard-bronze");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 44.9999648 0 44.9999648 47.9999652 0 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-480.000000, -489.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/word-wizard-bronze",
  transform: "translate(480.000000, 489.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999648,47.9999652 L22.4999648,47.9999652 C10.0736367,47.9999652 -3.515625e-05,38.0333565 -3.515625e-05,25.7390957 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,25.7390957 C44.9999648,38.0333565 34.926293,47.9999652 22.4999648,47.9999652",
  id: "Fill-1",
  fill: "#AF825D",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999648,44.5217043 L22.4999648,44.5217043 C10.0736367,44.5217043 -3.515625e-05,34.5550957 -3.515625e-05,22.2608348 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,22.2608348 C44.9999648,34.5550957 34.926293,44.5217043 22.4999648,44.5217043",
  id: "Fill-4",
  fill: "#E5B389",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812148,-3.47826087e-05 L4.21871484,-3.47826087e-05 C1.88891016,-3.47826087e-05 -3.515625e-05,1.86883478 -3.515625e-05,4.17387826 L-3.515625e-05,22.2608348 C-3.515625e-05,34.5550957 10.0736367,44.5217043 22.4999648,44.5217043 C34.926293,44.5217043 44.9999648,34.5550957 44.9999648,22.2608348 L44.9999648,4.17387826 C44.9999648,1.86883478 43.1110195,-3.47826087e-05 40.7812148,-3.47826087e-05 M40.7812148,4.17387826 L40.7812148,22.2608348 C40.7812148,32.2340522 32.5803164,40.3477913 22.4999648,40.3477913 C12.4196133,40.3477913 4.21871484,32.2340522 4.21871484,22.2608348 L4.21871484,4.17387826 L40.7812148,4.17387826",
  id: "Fill-7",
  fill: "#CF9C6D",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.6326289,10.4628522 C32.4361055,10.2072 32.1144258,10.0757217 31.7899336,10.0757217 L25.1742305,10.0757217 L25.140832,10.0757217 C21.912082,10.0757217 19.0071211,12.0169391 17.8009102,14.9800696 L12.942668,26.9181565 L31.9699336,26.9181565 L27.3001289,15.3445913 C27.0825117,14.805113 27.3331758,14.1915478 27.8686055,13.9529391 L32.2466133,12.0037217 C32.8319648,11.7432 33.0474727,11.0030261 32.6326289,10.4628522",
  id: "Fill-10",
  fill: "#AF825D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.3706836,29.5763826 L10.6293164,29.5763826 C9.78134766,29.5763826 9.09404297,28.8963826 9.09404297,28.0574261 C9.09404297,27.2181217 9.78134766,26.5381217 10.6293164,26.5381217 L34.3706836,26.5381217 C35.2186523,26.5381217 35.905957,27.2181217 35.905957,28.0574261 C35.905957,28.8963826 35.2186523,29.5763826 34.3706836,29.5763826",
  id: "Fill-12",
  fill: "#996844"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-14",
  fill: "#FFDC4A",
  points: "20.8757109 17.5495652 20.8757109 21.1798261 21.8766094 21.1798261 21.8766094 24.1502609 24.2116875 20.189913 22.8771563 20.189913 24.2116875 17.5495652"
})))));

var SvgWordWizardBronze = function SvgWordWizardBronze(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordWizardBronze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/word-wizard-bronze.88b20279.svg";
export { ForwardRef as ReactComponent };